<template>
  <div class="keyword-type-ahead">
    <div class="d-flex mb-3 position-relative">
        <type-ahead
            class="w-100"
            multiple
            :options="options"
            v-model="internalModel"
            @search="updateSearchValue"
            :reduce-option="reduceOption"
        />

      <b-button
          class="text-white add-button ml-2 d-flex"
          variant="primary"
          size="lg"
          @click.stop="() => addKeyword()"
          :disabled="!searchValue"
      >
        <i class="fas fa-plus" />
      </b-button>
    </div>

    <div>
      <div
          v-for="(keyword, index) in internalModel"
          class="keyword-chip mr-2 mb-2"
          :key="index + keyword"
      >
        {{ keyword }}
          <b-button
              type="button"
              class="fal fa-times icon-button text-gray-700 p-0"
              variant="ternary"
              @click.stop="() => removeKeyword(keyword)"
          />
      </div>
    </div>
  </div>
</template>

<script>
    import VModel from '@milestoneslabs/milestones-ui-kit/src/mixins/VModel';
    import TypeAhead from "@milestoneslabs/milestones-ui-kit/src/components/TypeAhead/TypeAhead";
    import './KeywordTypeAhead.scss';

    export default {
        name: 'KeywordTypeAhead',

        components: {
            TypeAhead,
        },

        mixins: [
            VModel,
        ],

        props: {
            options: {
                type: Array,
                default: () => [],
            }
        },

        data() {
            return {
                searchValue: '',
            };
        },

        methods: {
            updateSearchValue(search) {
                this.searchValue = search;
            },

            reduceOption(option) {
                if (!option) {
                    return null;
                }
                return option.text;
            },

            addKeyword() {
                this.internalModel.push(this.searchValue);
            },

            removeKeyword(option) {
                this.internalModel = this.internalModel.filter((keyword) => keyword !== option);
            }
        },
    };
</script>
